import { ethers } from 'ethers'
import web3 from 'web3'
// import axios from 'axios'
import { aferTokenAddress, seedSaleAddress,projectID} from '../config'
import AFER from '../abi/AFER.json'
import SeedSaleVesting from '../abi/SeedSaleVesting.json'
import {connectWallet,removeExponents} from './utils'
import Web3Modal from 'web3modal'
// import WalletConnect from "@walletconnect/web3-provider";
// import CoinbaseWalletSDK from "@coinbase/wallet-sdk";


// const providerOptions = {
//   walletlink: {
//     package: CoinbaseWalletSDK, // Required
//     options: {
//       appName: "Web 3 Modal Demo", // Required
//       infuraId: process.env.INFURA_KEY // Required unless you provide a JSON RPC url; see `rpc` below
//     }
//   },
//   walletconnect: {
//     package: WalletConnect, // required
//     options: {
//       infuraId: process.env.INFURA_KEY // required
//     }
//   }
// };


export const aferAddress = aferTokenAddress
export const seedAddress = seedSaleAddress

export const GetClientTokenStandings = async (clientAddress) =>{
  let message = ""
  try {
    const provider = new ethers.providers.JsonRpcProvider(
      // Leaving blank will automatically enable localhost
      `https://polygon-mumbai.infura.io/v3/${projectID}`,
    )
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, provider)
    const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,provider)
    const benficiary = await seedSaleContract.checkBeneficiary(clientAddress)
    
        const releaseTime = await seedSaleContract.releaseTime()
        const percentages = await seedSaleContract.getPercentages();
        let linearPercent = web3.utils.fromWei(percentages[1].toString(), 'ether')
        let tgePercent = web3.utils.fromWei(percentages[0].toString(), 'ether')
        const availableBalance = await tokenContract.balanceOf(clientAddress)
        let available = web3.utils.fromWei(availableBalance.toString(), 'ether')
        let locked = web3.utils.fromWei(benficiary._amount.toString(), 'ether')
        let total = parseFloat(available) + parseFloat(locked)
        let percent = benficiary.isTokenAtTGEReleased ? 
              parseFloat(linearPercent*100):
              parseFloat(tgePercent*100)
        let secondsEPOCH = benficiary.isTokenAtTGEReleased ?
                benficiary.monthlyReleaseTime.toString() :
                releaseTime.toString()
       
        let date = new Date(secondsEPOCH*1000)
        let item = {
          total: removeExponents(total.toString()),
          locked: removeExponents(locked),
          available: removeExponents(available),
          releasePercent: percent,
          releaseDate: date,
        }
        return item
  } catch (error) {
    let status = null
    let connection = null
    if(error.message.includes("resolver or addr is not configured for ENS name")){
      message = "Please Let's connect your wallet😊"
      alert(message)
      try {
        do {
          connection = await connectWallet()
          status = connection.status
          if(status.includes("Something went wrong: User Rejected")){
            message = "App won't work well until you connect your wallet😔"
            alert(message)
          }else if(status.includes("Wallet successfuly connected.")){
            alert(status)
            window.open(window.location.pathname, '_self')
          }else{
            message = "Something went wrong😔"
            alert(message)
          }
        } while (status.includes("Something went wrong: User Rejected"));

      } catch (error) {
        console.log(error.message)
        if(error.message.includes("User rejected") || error.message.includes("User RSejected") || error.message.includes("resolver or addr is not configured for ENS name")){
          message = "App won't work well until you connect your wallet😔"
          alert(message)
        }else{
          message = "Something went wrong😔"
          
          alert(message)
        }
      }
    }else {
      message = "Something went wrong😔 : " + error.message
      alert(message)
    }
  }
  console.log(message.toString())
   return {}
}


export const requestReleaseMyToken = async () =>{

  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect()
      const provider = new ethers.providers.Web3Provider(connection)
      const signer = provider.getSigner()
    
    const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    await seedSaleContract.releaseMyToken()
  } catch (error) {
    let message = null
    let errorType = typeof(error)
    if(errorType === 'object'){
      if(error.data.message.includes("Not beneficiary!")){
        message = "Your current connected address isn't a beneficiary!\nIf you participated in the seed sale, try switching to the address you used\nIf you still end up here, then please contact an admin."
        alert(message)
      }else if(error.data.message.includes("Set Beneficiary")){
        message = "No beneficiary has been set\nWait or Contact admin about this error."
        alert(message)
      }else if(error.data.message.includes("Vesting: current time is before release time")){
        message = "Vesting: current time is before release time"
        alert(message)
      }else if(error.data.message.includes("Wait after 2m") || error.data.message.includes("Wait after 2months")){
        message = "We're having a two month clif time.\nCome back after two months and request again😊"
        alert(message)
      }else if(error.data.message.includes("Vesting: no tokens to release")){
        message = "No tokens currently vesting\nOr\nAll tokens released"
        alert(message)
      }else if(error.data.message.includes("Vesting: all tokens released")){
        message = "Vesting: all tokens released😊"
        alert(message)
      }else if(error.data.message.includes("Wait after 1month")){
        message = "Wait after a month then request again!"
        alert(message)
      }else{
        message = "Something is wrong, please show this to admin : " + error.data.message
        alert(message)
      }
    }else{
      alert("Something is wrong! : "+ error.message)
    }
  }

}


export const requestReleaseAllToken = async () =>{

  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect()
      const provider = new ethers.providers.Web3Provider(connection)
      const signer = provider.getSigner()
    
    const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    await seedSaleContract.release()
  } catch (error) {
    let message = null
    let errorType = typeof(error)
    if(errorType === 'object'){
      if(error.data.message.includes("Only Admins")){
        message = "You don't have the permission to do this!"
        alert(message)
      }else if(error.data.message.includes("Not beneficiary!")){
        message = "Your current connected address isn't a beneficiary!\nIf you participated in the seed sale, try switching to the address you used\nIf you still end up here, then please contact an admin."
        alert(message)
      }else if(error.data.message.includes("Set Beneficiary")){
        message = "No beneficiary has been set\nWait or Contact admin about this error."
        alert(message)
      }else if(error.data.message.includes("Vesting: current time is before release time")){
        message = "Vesting: current time is before release time"
        alert(message)
      }else if(error.data.message.includes("Wait after 2m") || error.data.message.includes("Wait after 2months")){
        message = "We're having a two month clif time.\nCome back after two months and request again😊"
        alert(message)
      }else if(error.data.message.includes("Vesting: no tokens to release")){
        message = "No tokens currently vesting\nOr\nAll tokens released"
        alert(message)
      }else if(error.data.message.includes("Vesting: all tokens released")){
        message = "Vesting: all tokens released😊"
        alert(message)
      }else if(error.data.message.includes("Wait after 1month")){
        message = "Wait after a month then request again!"
        alert(message)
      }else{
        message = "Something is wrong, please show this to admin : " + error.data.message
        alert(message)
      }
    }else{
      alert("Something is wrong! : "+ error.message)
    }
  }

}


export const setBeneficiary = async (beneficiaryAddress, amount) =>{

  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect()
      const provider = new ethers.providers.Web3Provider(connection)
      const signer = provider.getSigner()
    
    const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    await seedSaleContract.setBeneficiary(beneficiaryAddress, amount)
  } catch (error) {
    let message = null
    let errorType = typeof(error)
    if(errorType === 'object'){
      console.log(error);
      if(error.data.message.includes("Only Admins")){
        message = "You don't have the permission to do this!"
        alert(message)
      }else if(error.data.message.includes("Address exists")){
        message = "Address must be unique for each beneficiary.\nThis address already exists."
        alert(message)
      }else{
        message = "Something is wrong, please show this to admin : " + error.data.message
        alert(message)
      }
    }else{
      alert("Something is wrong! : "+ error.message)
    }
  }

}


export const isUserAdmin = async () =>{
  let response = false;
  try {
    const result = await connectWallet()
    const connectedAddress = result.address
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect()
      const provider = new ethers.providers.Web3Provider(connection)
      provider.getSigner()
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, provider)
    let data = await tokenContract.getAdmin()

    for (let i = 0; i < data.length; i++) {
      if(data[i].toLowerCase() === connectedAddress.toLowerCase()){
        response = true;
      }
      if(data[i].toLowerCase() !== connectedAddress.toLowerCase()){
        response = false;
      }
    }
  } catch (error) {
    alert("Error occured : "+ error.message)
  }
return response
} 


// Tranfer token 
export const transferToken = async (toAddress, amount) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect()
      const provider = new ethers.providers.Web3Provider(connection)
      const signer = provider.getSigner()
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer)

    await tokenContract.transfer(toAddress, amount);

  } catch (error) {
    alert("Error occured : "+ error.message)
  }
return true;
}

// Tranfer token from a particular address
export const transferTokenFromContract = async (toAddress, amount) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect()
      const provider = new ethers.providers.Web3Provider(connection)
      const signer = provider.getSigner()
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer)

    await tokenContract.transfer(toAddress, amount)

  } catch (error) {
    alert("Error occured : "+ error.message)
  }
return true;
}

// Tranfer token form a particular address
export const transferTokenFrom = async (fromAddress, toAddress, amount) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect()
      const provider = new ethers.providers.Web3Provider(connection)
      const signer = provider.getSigner()
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer)

    await tokenContract.transferFrom(fromAddress,toAddress, amount)

  } catch (error) {
    alert("Error occured : "+ error.message)
  }
return true;
}


// promot a particular address to become an admin
export const promoteToAdmin = async (adminAddress) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.promotToAdmin(adminAddress);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

// Transfer ownership of your AFER token to someone else
export const transferTokenOwnership = async (newOwnerAddress) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.transferOwnership(newOwnerAddress);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

// pause the operation of the afer token
export const pauseToken = async () =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.pause();

  } catch (error) {
    let message = null
    let errorType = typeof(error)
    if(errorType === 'object'){
      if(error.message.includes("User denied")){
        message = "You canceled the transaction";
        alert(message)
      }else if(error.data.message.includes("Only Admins")){
        message = "You don't have the permission to do this!"
        alert(message)
      }else if(error.data.message.includes("paused")){
        message = "Token Already Paused"
        alert(message)
      }else{
        message = "Something is wrong, please show this to admin : " + error.data.message
        alert(message)
      }
    }else{
      alert("Something is wrong! : "+ error.message)
    }
  }
return true;
}

// unpause the operation of the afer token
export const unpauseToken = async () =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.unpause();

  } catch (error) {
    let message = null
    let errorType = typeof(error)
    if(errorType === 'object'){
      if(error.data.message.includes("Only Admins")){
        message = "You don't have the permission to do this!"
        alert(message)
      }else if(error.data.message.includes("not paused")){
        message = "Token Not Paused"
        alert(message)
      }else{
        message = "Something is wrong, please show this to admin : " + error.data.message
        alert(message)
      }
    }else{
      alert("Something is wrong! : "+ error.message)
    }
  }
return true;
}


// approve someone to spend on your behalf
export const approveSomeAddress = async (spenderAddress, amount) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.approve(spenderAddress, amount);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

// burn some token
export const burnToken = async (amountToBurn) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.burn(amountToBurn);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

// burn some token from a specific address
export const burnTokenFrom = async (addressToBurnFrom,amountToBurn) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.burnFrom(addressToBurnFrom,amountToBurn);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

//increase token allowance for a spender
// It's best to decrease the token to 0 before increase it
export const increaseTokenAllowance = async (spenderAddress,amountToIncrease) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.increaseAllowance(spenderAddress,amountToIncrease);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

// decrease token allowance for a spender
export const decreaseTokenAllowance = async (spenderAddress,amountToDecrease) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.decreaseAllowance(spenderAddress,amountToDecrease);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

//Renounce ownership of your token
export const renounceTokenOwnership = async () =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.renounceOwnership();

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

//Mint new AFER token
export const mintNewToken = async (toAddress, amountToMint) =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,signer)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    await tokenContract.mint(toAddress, amountToMint);

  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return true;
}

//AFER Token Summary!
export const tokenSummary = async () =>{
  try {
    const web3Modal = new Web3Modal({
      network: 'mumbia',
      cacheProvider: true,
    });
      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
    
    // const seedSaleContract = new ethers.Contract(seedSaleAddress,SeedSaleVesting.abi,provider)
    const tokenContract = new ethers.Contract(aferTokenAddress, AFER.abi, signer);

    const initialSupply = await tokenContract.getInitialSupply();
    const totalAmountInCirculation = await tokenContract.totalSupply();
    let totalAmountReserved = 0;
    let additionalAmountMinted = (totalAmountInCirculation - initialSupply)/10**18;
    let totalAmountSold = 0;
    let data = {
      initialSupply:(initialSupply/10**18).toString(),
      totalAmountInCirculation:(totalAmountInCirculation/10**18).toString(),
      totalAmountSold:totalAmountSold.toString(),
      totalAmountReserved:totalAmountReserved.toString(),
      additionalAmountMinted: additionalAmountMinted.toString()
    }
    return data;
  } catch (error) {
    alert("Error occured : "+ error.message);
  }
return {};
}
